import React, { useEffect, useState } from "react"
import styles from "./filters.module.scss"
import overlayStyles from "./overlay.module.scss"

const Filters = ({ allItems, items, setItems, setFilteredColor, isBags }) => {
  const [filtersOpen, setFiltersOpen] = useState(false)

  const [sizeOptionOpen, setSizeOptionOpen] = useState(false)
  const [sizeOrigin, setSizeOrigin] = useState("US")
  const [allSizes, setAllSizes] = useState(true)
  const [sizes, setSizes] = useState({
    "35": false,
    "35.5": false,
    "36": false,
    "36.5": false,
    "37": false,
    "37.5": false,
    "38": false,
    "38.5": false,
    "39": false,
    "39.5": false,
    "40": false,
    "40.5": false,
    "41": false,
    "41.5": false,
    "42": false,
  })

  const [colorOptionOpen, setColorOptionOpen] = useState(false)
  const [allColors, setAllColors] = useState(true)
  const [colors, setColors] = useState({
    "Black": false,
    "White": false,
    "Grey": false,
    "Blue": false,
    "Purple": false,
    "Green": false,
    "Brown": false,
    "Neutrals": false,
    "Red": false,
    "Orange": false,
    "Yellow": false,
    "Pink": false,
    "Animal": false,
    "Metallic": false,
    "Multi": false,
  })

  const [heelHeightOptionOpen, setHeelHeightOptionOpen] = useState(false)
  const [allHeelHeights, setAllHeelHeights] = useState(true)
  const [heelHeights, setHeelHeights] = useState({
    "Flat 0 – 1 inch": false,
    "Low 1 – 2 inches": false,
    "Medium 2 – 3 inches": false,
    "High 3 – 4+ inches": false,
  })

  const [sortOpen, setSortOpen] = useState(false)
  const [sort, setSort] = useState("Featured")
  const sortOptions = [
    "Featured",
    "Newest",
    // "Best selling",
    "Price low to high",
    "Price high to low",
  ]

  const [availableSizes, setAvailableSizes] = useState(new Set())
  const [availableColors, setAvailableColors] = useState(new Set())
  const [availableHeelHeights, setAvailableHeelHeights] = useState(new Set())

  const resetOptions = options => {
    let temp = {}
    Object.keys(options).forEach(key => temp[key] = false)
    return temp
  }

  const resetFilters = () => {
    // TODO: Is there a better way to do this?
    setSizes({...resetOptions(sizes)})
    setAllSizes(true)
    setColors({...resetOptions(colors)})
    setAllColors(true)
    setHeelHeights({...resetOptions(heelHeights)})
    setAllHeelHeights(true)
  }

  // Update allSizes value based on sizes selected
  useEffect(() => {
    let anySize = false
    Object.values(sizes).forEach(value => {
      anySize = anySize || value
    })
    setAllSizes(!anySize)
  }, [sizes])

  // Update allColors value based on colors selected
  useEffect(() => {
    let anyColor = false
    Object.values(colors).forEach(value => {
      anyColor = anyColor || value
    })
    // If a color is selected, set the filtered color to that color
    if (anyColor)
      setFilteredColor(Object.entries(colors).find(c => c[1])[0])
    else
      setFilteredColor(null)
    setAllColors(!anyColor)
  }, [colors, setFilteredColor])

  // Update allHeelHeights value based on heel heights selected
  useEffect(() => {
    let anyHeelHeight = false
    Object.values(heelHeights).forEach(value => {
      anyHeelHeight = anyHeelHeight || value
    })
    setAllHeelHeights(!anyHeelHeight)
  }, [heelHeights])

  // Filter items by size/color/heel height
  useEffect(() => {
    const sortItems = itemsToSort => {
      if (sort === "Featured")
        return itemsToSort.sort((a,b) => a.featured_order - b.featured_order)
      if (sort === "Newest")
        return itemsToSort.sort((a,b) => new Date(b.published_at) - new Date(a.published_at))
      if (sort === "Price low to high")
        return itemsToSort.sort((a,b) => Number(a.skus[0].variants[0].price) - Number(b.skus[0].variants[0].price))
      if (sort === "Price high to low")
        return itemsToSort.sort((a,b) => Number(b.skus[0].variants[0].price) - Number(a.skus[0].variants[0].price))
      return itemsToSort
    }

    setItems([])
    let filteredItems = (allSizes && allColors && allHeelHeights) ?
      allItems
      :
      allItems.filter(item => {
        // Filter by size (if size selected)
        let hasSize = false
        if (allSizes) hasSize = true
        else {
          item.skus.forEach(sku => {
            sku.variants.forEach(variant => {
              if (sizes[variant.size] && variant.quantity > 0)
                hasSize = true
            })
          })
        }
        // Filter by color (if color selected)
        let hasColor = false
        if (allColors) hasColor = true
        else {
          item.skus.forEach(sku => {
            if (colors[sku.colorFamily])
              hasColor = true
          })
        }
        // Filter by heel height (if heel height selected)
        let hasHeelHeight = false
        if (allHeelHeights) hasHeelHeight = true
        else {
          const hhNumber = Number(item.heel_height.replace("mm",""))
          if ((heelHeights["Flat 0 – 1 inch"] && (hhNumber < 25.4 || isNaN(hhNumber))) ||
            (heelHeights["Low 1 – 2 inches"] && hhNumber > 25.4 && hhNumber < 50.8) ||
            (heelHeights["Medium 2 – 3 inches"] && hhNumber > 50.8 && hhNumber < 76.2) ||
            (heelHeights["High 3 – 4+ inches"] && hhNumber > 76.2))
            hasHeelHeight = true
        }
        return hasSize && hasColor && hasHeelHeight
      })

    setTimeout(() => {
      setItems([...sortItems(filteredItems)])
    }, 100)

    // Heap
    if (window.hasOwnProperty("heap"))
      window.heap.track("Apply Filter")
  }, [sizes, allSizes, colors, allColors, heelHeights, allHeelHeights, sort, allItems, setItems])

  // Set which colors and heel heights are available given all items
  useEffect(() => {

    let availableColorsSet = new Set()
    let availableHeelHeightsSet = new Set()

    allItems.forEach(item => {
      const hhNumber = Number(item.heel_height.replace("mm",""))
      if (hhNumber < 25.4 || isNaN(hhNumber))
        availableHeelHeightsSet.add("Flat 0 – 1 inch")
      else if (hhNumber > 25.4 && hhNumber < 50.8)
        availableHeelHeightsSet.add("Low 1 – 2 inches")
      else if (hhNumber > 50.8 && hhNumber < 76.2)
        availableHeelHeightsSet.add("Medium 2 – 3 inches")
      else if (hhNumber > 76.2)
        availableHeelHeightsSet.add("High 3 – 4+ inches")
      item.skus.forEach(sku => {
        availableColorsSet.add(sku.colorFamily)
      })
    })

    setAvailableColors(availableColorsSet)
    setAvailableHeelHeights(availableHeelHeightsSet)
  }, [allItems])

  // Set which sizes are still available given the filtered items
  useEffect(() => {

    let availableSizesSet = new Set()

    items.forEach(item => {
      item.skus.forEach(sku => {
        sku.variants.forEach(variant => {
          if (variant.quantity > 0)
            availableSizesSet.add(variant.size)
        })
      })
    })

    setAvailableSizes(availableSizesSet)
  }, [items])

  // Close filters if clicked out of
  const handleOutsideFilterClick = e => {
    if (sizeOptionOpen || colorOptionOpen || heelHeightOptionOpen || sortOpen) {
      const clickedOnFilter = e.path.some(el => {
        return el && el.className && el.className.includes("filter")
      })
      if (!clickedOnFilter) {
        setSizeOptionOpen(false)
        setColorOptionOpen(false)
        setHeelHeightOptionOpen(false)
        setSortOpen(false)
      }
    }
  }

  useEffect(() => {
    if (typeof window !== "undefined")
      document.addEventListener("click", handleOutsideFilterClick)
    return () =>
      document.removeEventListener("click", handleOutsideFilterClick)
  })

  return(
    <div className={styles.filters}>
      <p className={styles.itemCount}>{items.length} item{items.length !== 1 ? "s" : ""}</p>
      <div className={`${(filtersOpen) ? styles.optionsOpen : styles.options} ${(sortOpen) ? styles.optionsSortOpen : ""}`}>
        <button
          className={`${styles.optionLabel} ${styles.filterBtn}`}
          onClick={e => setFiltersOpen(true)}
        >Filter</button>
        <div
          className={styles.overlay}
          role="presentation"
          onClick={e => {
            setFiltersOpen(false)
            setSortOpen(false)
          }}
        />
        <div className={styles.optionsDrawer}>
          <ul className={(!isBags) ? styles.optionsDrawerList : styles.optionsDrawerListBags}>
            {!isBags &&
              <li>
                <Options
                  label="Size"
                  options={sizes}
                  setOptions={setSizes}
                  optionOpen={sizeOptionOpen}
                  setOptionOpen={setSizeOptionOpen}
                  setOtherOption1Open={setColorOptionOpen}
                  setOtherOption2Open={setHeelHeightOptionOpen}
                  availableOptions={availableSizes}
                  {...{
                    setSortOpen,
                    sizeOrigin,
                    setSizeOrigin,
                  }}
                />
              </li>
            }
            <li>
              <Options
                label="Color"
                options={colors}
                setOptions={setColors}
                optionOpen={colorOptionOpen}
                setOptionOpen={setColorOptionOpen}
                setOtherOption1Open={setSizeOptionOpen}
                setOtherOption2Open={setHeelHeightOptionOpen}
                availableOptions={availableColors}
                {...{
                  setSortOpen,
                }}
              />
            </li>
            {!isBags &&
              <li>
                <Options
                  label="Heel Height"
                  options={heelHeights}
                  setOptions={setHeelHeights}
                  optionOpen={heelHeightOptionOpen}
                  setOptionOpen={setHeelHeightOptionOpen}
                  setOtherOption1Open={setSizeOptionOpen}
                  setOtherOption2Open={setColorOptionOpen}
                  availableOptions={availableHeelHeights}
                  isHeelHeights={true}
                  {...{
                    setSortOpen,
                  }}
                />
              </li>
            }
          </ul>
          <div className={styles.buttons}>
            <button
              className={styles.applyBtn}
              onClick={e => setFiltersOpen(false)}
            >
              See Items
            </button>
            <button
              className={styles.clearBtn}
              onClick={resetFilters}
            >
              Clear Filters
            </button>
          </div>
        </div>
        <button
          className={(sortOpen) ? styles.optionLabelOpen : styles.optionLabel}
          onClick={() => {
            setSortOpen(!sortOpen)
            setSizeOptionOpen(false)
            setColorOptionOpen(false)
            setHeelHeightOptionOpen(false)
          }}
        >Sort</button>
        <div className={(sortOpen) ? styles.sortContainerOpen : styles.sortContainer}>
          <button
            className={`${overlayStyles.closeBtn} ${styles.closeBtn}`}
            onClick={e => setSortOpen(false)}
            title="Close"
          >Close</button>
          <h5 className={styles.heading}>Sort by</h5>
          <ul className={styles.optionList}>
            {sortOptions.map((sortOption, i) => (
              <li
                key={i}
                className={styles.radio}
              >
                <input
                  type="radio"
                  name="sort"
                  id={sortOption}
                  checked={sortOption === sort}
                  onChange={e => setSort(sortOption)}
                />
                <label htmlFor={sortOption}>
                  {sortOption}
                </label>
              </li>
            ))}
          </ul>
          <button
            className={styles.applyBtn}
            onClick={e => setSortOpen(false)}
          >
            Apply Sort
          </button>
        </div>
      </div>
      {(!allSizes || !allColors || !allHeelHeights) &&
        <div className={styles.activeFilters}>
          <ul>
            {Object.keys(sizes).sort().map((size, i) => (
              <ActiveFilter
                options={sizes}
                option={size}
                setOption={setSizes}
                label="Size"
                key={i}
              />
            ))}
            {Object.keys(colors).map((color, i) => (
              <ActiveFilter
                options={colors}
                option={color}
                setOption={setColors}
                key={i}
              />
            ))}
            {Object.keys(heelHeights).map((heelHeight, i) => (
              <ActiveFilter
                options={heelHeights}
                option={heelHeight}
                setOption={setHeelHeights}
                key={i}
              />
            ))}
            <li className={styles.clearActive}>
              <button
                onClick={resetFilters}
              >
                Clear Filters
              </button>
            </li>
          </ul>
        </div>
      }
    </div>
  )
}

export default Filters

const ActiveFilter = ({ options, option, setOption, label }) => {

  return(
    <>
      {options[option] &&
        <li>
          <button
            className={styles.activeFilter}
            onClick={e => {
              setOption({
                ...options,
                [option]: false
              })
            }}
          >
            {label} {option}
            <span
              className={styles.removeIcon}
            >
            Remove
          </span>
          </button>
        </li>
      }
    </>
  )
}

const Options = props => {
  const {
    label,
    options,
    setOptions,
    optionOpen,
    setOptionOpen,
    setOtherOption1Open,
    setOtherOption2Open,
    setSortOpen,
    availableOptions,
    sizeOrigin,
    setSizeOrigin,
    isHeelHeights,
  } = props

  const optionKeys = (sizeOrigin) ? Object.keys(options).sort() : Object.keys(options)

  return(
    <>
      <button
        className={(optionOpen) ? styles.optionLabelOpen : styles.optionLabel}
        onClick={() => {
          setOtherOption1Open(false)
          setOtherOption2Open(false)
          setSortOpen(false)
          setOptionOpen(!optionOpen)
        }}
      >
        {label}
      </button>
      <div
        className={`${(optionOpen) ? styles.optionContainerOpen : styles.optionContainer} ${(isHeelHeights) ? styles.heelHeightContainer : ""}`}>
        {sizeOrigin &&
          <div className={styles.sizeOrigins}>
            <button
              className={(sizeOrigin === "EU") ? styles.selected : ""}
              onClick={() => setSizeOrigin("EU")}
            >
              EU
            </button>
            &nbsp;|&nbsp;
            <button
              className={(sizeOrigin === "US") ? styles.selected : ""}
              onClick={() => setSizeOrigin("US")}
            >
              US
            </button>
          </div>
        }
        <ul className={styles.optionList}>
          {optionKeys.map((option, i) => (
            <li
              key={i}
              className={(availableOptions.has(option)) ? styles.option : styles.optionUnavailable}
            >
              <input
                type="checkbox"
                name={option}
                id={option}
                checked={options[option]}
                onChange={e => {
                  setOptions({
                    ...options,
                    [e.target.name]: !options[e.target.name]
                  })
                }}
              />
              <label htmlFor={option}>
                {(sizeOrigin && sizeOrigin === "US") ?
                  Number(option) - 30
                  :
                  option
                }
              </label>
            </li>
          ))}
        </ul>
      </div>
    </>
  )
}
